import rentObjectChannelsService from "@/services/rentObjectChannelsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await rentObjectChannelsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Konfigurations wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Konfiguration konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await rentObjectChannelsService.findAll(formData);
      commit("setAllFeatureTags", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async synchronize({ dispatch }, formData) {
    try {
      const res = await rentObjectChannelsService.synchronize(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnte nicht synchronisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async synchronizePictures({ dispatch }, formData) {
    try {
      const res = await rentObjectChannelsService.synchronizePictures(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel Bilder konnten nicht synchronisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async deleteTraumferienwohnungenImage({ dispatch }, formData) {
    try {
      const res = await rentObjectChannelsService.deleteTraumferienwohnungenImage(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Bilder konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getPictures({ dispatch }, formData) {
    try {
      const res = await rentObjectChannelsService.getPictures(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel Bilder konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectChannelsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Channel wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
